<template>
    <transition>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-alert-header" :style="{'background-color': '#5bc36e'}">
                        <div class="modal-alert-header-text">결과보기</div>
                        <div class="modal-alert-header-close" @click="$emit('close')"></div>
                    </div>
                    <div class="modal-alert-body">
                        <div class="modal-alert-body-inner">
                            <div v-if="isLoading" v-bind:class="{ scrtc_loading_hide:!isLoading, scrtc_loading_show:isLoading  }">
                                <div class="loading_text">{{ txtLoading }}</div>
                            </div>
                            <iframe id="scrtc_iframe" 
                                v-bind:class="{ scrtc_iframe_hide:isLoading, scrtc_iframe_show:!isLoading  }"
                                allow="auto" :src="scrtc_path" frameborder="0" ref="scrtc_iframe" scrolling= "no"
                            />
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </transition>
</template>
<script>
import axios from 'axios';
export default {
    name: 'LearningResultModal',
    props: ['beginInfo'],
    data() {
        return {
            url: "",
            isLoading:true,
            cntLoading:0,
            txtLoading:'잠시만 기다려 주십시요.',
            scrtc_iframe: '',
            scrtc_path: '',
        }
    },
    created() {
    },
    mounted () {
        if(window.VUE_APP_NODE_ENV === 'development'){
            this.scrtc_path = '/blk-sc/scrtc/player';
            // console.log(`[Scrtch::Workspace.vue] Dev - scrtch_path : ${this.scrtc_path}`);
        }else{
            this.scrtc_path = '/blk-sc/scrtc/player';
            // console.log(`[Scrtch::Workspace.vue] Test&Prod - scrtch_path : ${this.scrtc_path}`);
        }
        this.scrtc_iframe = this.$refs.scrtc_iframe;

        let that = this;
        const iframe = document.getElementById('scrtc_iframe')
        iframe.onload = () => {
            that.isLoading = false;
        }

        // 초당 한번씩 로딩 메시지 업데이트
        let v = this;
        var ck = setInterval(function(){
            // 문구 로딩 종료
            if(!v.isLoading){
                clearInterval(ck);
                that.scratchLoad(iframe, that.beginInfo);
            }
            // 문구 업데이트
            else{
                ++v.cntLoading;
                let remain = v.cntLoading%3;
                // console.log('[cntLoading : '+v.cntLoading+' | remain : '+remain)
                switch(remain){
                    case 0: v.txtLoading='잠시만 기다려 주십시요.'; break;
                    case 1: v.txtLoading='잠시만 기다려 주십시요..'; break;
                    case 2: v.txtLoading='잠시만 기다려 주십시요...'; break;
                } 
            } 
        }, 1000);
    },
    methods: {
        scratchLoad(iframe, project) {
            axios.get(project)
                .then(res => {
                    const sliceSize = 512;
                    const b64Data = res.data;
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];                    
                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);
                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }                    
                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    const blob = new Blob(byteArrays);
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    if (reader) {
                        reader.onload = () => {
                            iframe.contentWindow.postMessage({
                                'sender': 'Load',
                                'blobData': reader.result,
                                'host': 'Vue' // origin 구별하기 위한 코드.
                            }, '*')
                        };
                    }
                });
        },
    },
}
</script>
<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 602px;
        max-height:583px;
        min-height:400px;
        margin: 0px auto;        
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
    .modal-alert-header{
        /* margin-top: 0;
        color: #42b983; */
        display: flex;
        background-color: #5096f5;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .modal-alert-header-text {
        display: inline-block;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin: 0 26px;
        height: 54px;
        line-height: 54px;
        font-family: nanumBarunLight;
        font-size: 18px;
        color: #fff;
    }
    .modal-alert-header-close{
        display: inline-block;
        cursor: pointer;
        right: 0;
        margin: 16px 26px 0 0;
        width: 22px;
        height: 22px;
        background-image: url('../../../assets/images/popupClose.png');
        background-repeat: no-repeat;
    }
    .modal-alert-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 457px;
    }
    .modal-alert-body-inner{
        overflow-x:hidden;
        overflow-y:hidden;
        width: 514px;
        height: 100%;
        font-family: nanumBarunLight;
        font-size: 16px;
        text-align: center;
        overflow: hidden;
        word-break: break-word;
        // margin: 34px 36px;
    }
    .modal-default-button {
        float: right;
    }
    .modal-btn-default{
        display: inline-block;
        width: 105px;
        height: 40px;
        margin: 29px 10px 30px;
        border-radius: 3px;
        border: 1px solid #5848b8;
        color: #fff;
        background-color: #6e5ae6;
        text-align: center;
        line-height: 40px;
        font-family: nanumBarunLight;
        font-size: 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .modal-btn-default.modal-btn-cancle{
        background-color: #d8d8d8;
        border: 1px solid #9b9b9b;
        color: #3b3b3b;
    }
    .modal-enter {
        opacity: 0;
    }
    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .subject-text {
        display: inline-block;
        width: 100%;
        height: 34px;
        padding: 0 10px;
        vertical-align: middle;
        border: 0px;
        color: #fff;
        font-weight: 900;
        font-size: 16px;
        background-color: #5096f5;
        font-family: "Noto Sans KR";
    }
    .scrtc_main {
        // position: relative;
        position: absolute;
        width: 100%;
        height: 100%;
        //   height: calc(100% - 50px);
        //overflow: auto;
        background-color: #5096f5;
        //background-color: red;
    }
    .scrtc_loading_show{
        margin-top: 50px;
        width: 100%;
        height: 80%;
        // display: block;
        background-color: #5096f5;
        // background-color: red;   
        display : flex;
        align-items : center;
        justify-content: center;
        .loading_text{
            color: #fff;
            // background-color: #5096f5;
            font-weight: 900;
            font-size: 25px;
            font-family: "Noto Sans KR";
            vertical-align: middle;
        }
    }
    .scrtc_loading_hide{
        width: 0%;
        height: 0%;
        display: none;
        background-color: #5096f5;      
    }
    .scrtc_iframe {
        width: 100%;
        height: 100%;
        display: block;
    }
    .scrtc_iframe_hide {
        width: 100%;
        height: 100%;
        display: none;
    }
    .scrtc_iframe_show {
        margin-top: 21px;
        margin-left: 10px;
        width: 100%;
        height: 100%;
        display: block;
    }
</style>